export const siteMenu = [
  [
    {
      label: 'Superlógica',
      menu: [
        {
          label: 'Página inicial',
          to: 'https://superlogica.com/'
        },
        {
          label: 'Blog',
          to: 'https://blog.superlogica.com/'
        },
        {
          label: 'Suporte',
          to: 'https://superlogica.com/suporte/'
        },
        {
          label: 'Desenvolvedores',
          to: 'https://superlogicaimobiliarias.docs.apiary.io/'
        }
      ]
    },
    {
      label: 'Sobre a Superlógica',
      menu: [
        {
          label: 'Status',
          to: 'http://status.superlogica.com/'
        },
        {
          label: 'Carreiras',
          to: 'http://carreiras.superlogica.com/'
        }
      ]
    }
  ],
  [
    {
      label: 'Softwares',
      menu: [
        {
          label: 'Condomínios',
          to: 'https://superlogica.com/condominios/'
        },
        {
          label: 'Imobiliárias',
          to: 'https://superlogica.com/imobiliarias/'
        },
        {
          label: 'Assinaturas',
          to: 'https://superlogica.com/assinaturas/'
        }
      ]
    },
    {
      label: 'Serviços Financeiros',
      menu: [
        {
          label: 'Receber com boleto',
          to: 'https://superlogica.com/condominios/servicos-financeiros/boleto/'
        },
        {
          label: 'Receber com cartão de crédito',
          to: 'https://superlogica.com/condominios/servicos-financeiros/cartao/'
        },
        {
          label: 'Parcelamento no cartão de crédito',
          to:
            'https://superlogica.com/condominios/servicos-financeiros/parcelamento/'
        },
        {
          label: 'Inadimplência Zero',
          to:
            'https://superlogica.com/condominios/servicos-financeiros/inadimplencia/'
        }
      ]
    }
  ],
  [
    {
      label: 'Eventos',
      menu: [
        {
          label: 'Superlógica Xperience',
          to: 'https://xperience.superlogica.com/'
        },
        {
          label: 'Superlógica Next',
          to: 'https://next.superlogica.com/'
        }
      ]
    }
  ],
  [
    {
      label: 'Contato',
      menu: [
        {
          label: '0800 709 6800',
          to: 'tel:08007096800'
        },
        {
          label: '(19) 4009 6800',
          to: 'tel:1940096800'
        }
      ]
    },
    {
      label: 'Assessoria de Imprensa',
      menu: [
        {
          label: 'imprensa@superlogica.com',
          to: 'mailto:imprensa@superlogica.com'
        }
      ]
    }
  ]
]

export const juridicMenu = [
  {
    label: 'Política de privacidade',
    to: 'https://superlogica.com/privacidade/'
  },
  {
    label: 'Termos e Serviços',
    to: 'https://superlogica.com/termodeservico.pdf'
  },
  {
    label: 'Status',
    to: 'http://status.superlogica.com/'
  },
  {
    label: 'Código de Ética',
    to: 'https://superlogica.com/etica/'
  }
]
